<div *ngIf="examinationsProgressView !== null" class="progress-container-border">
    <app-progress-indicator [title]="'Status preiskav'" [percentage]="examinationsProgressView"></app-progress-indicator>
</div>

<ng-container *ngFor="let cExam of examinationsForReservationView">
    <div class="d-flex justify-content-between p-1" [ngClass]="{ 'dropDownItem rowItem p-2': !mini }">
        <div (click)="cExam.editAction()" class="w-100" [ngClass]="{ 'd-flex justify-content-between': mini }">
            <span class="m--font-boldest text-nowrap-ellipsis mr-2">{{ cExam.examination?.name || cExam.name }}</span>
            <div
                class="text-nowrap"
                [ngClass]="{
                    'm--font-danger': cExam.status !== reservationExaminationStatus.OK,
                    'm--font-success': cExam.status === reservationExaminationStatus.OK
                }"
            >
                {{ cExam.statusText || (cExam.status | examinationStatus: cExam.type) }}
            </div>
        </div>
        <app-dropdown *ngIf="!mini" [definition]="cExam.dropdownDefinition"></app-dropdown>
    </div>
</ng-container>
